'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactHoc = require('@mindz/react-hoc');

var _CalendarModule = require('./Calendar.module.css');

var _CalendarModule2 = _interopRequireDefault(_CalendarModule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ArrowIcon = function ArrowIcon(props) {
  return _react2.default.createElement('svg', props, _react2.default.createElement('path', {
    d: 'M1 1l4 4-4 4',
    className: 'arrowStroke',
    strokeWidth: '1.2',
    fill: 'none',
    fillRule: 'evenodd',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }));
};

ArrowIcon.defaultProps = {
  viewBox: '0 0 6 10',
  xmlns: 'http://www.w3.org/2000/svg'
};
var i18n = {
  'pl-PL': {
    months: ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień'],
    weekdaysShort: ['pon.', 'wt.', 'śr.', 'czw.', 'piąt.', 'sob.', 'niedz.'],
    week: {
      dow: 1
    }
  }
};

var Calendar = function (_Component) {
  _inherits(Calendar, _Component);

  function Calendar(props) {
    _classCallCheck(this, Calendar);

    var _this = _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props));

    _this.setDay = function (day) {
      var _this$props = _this.props,
          handleChange = _this$props.handleChange,
          getDateString = _this$props.getDateString,
          dateFormat = _this$props.dateFormat;
      var date = _this.state.date;
      var newDate = (0, _moment2.default)(date, dateFormat).date(day);

      _this.setDate(newDate, dateFormat);

      handleChange(newDate);
      getDateString(newDate.format(dateFormat));
    };

    _this.renderDayNames = function () {
      return _moment2.default.weekdaysShort().map(function (day) {
        return _react2.default.createElement('li', {
          key: day
        }, day);
      });
    };

    var language = _this.props.language;

    if (language !== 'en-US') {
      _moment2.default.updateLocale(language, _extends({}, i18n[language]));
    }

    _this.state = {
      date: (0, _moment2.default)(),
      firstDayInMonth: (0, _moment2.default)().startOf('month').weekday(),
      daysInMonth: (0, _moment2.default)().daysInMonth()
    };
    return _this;
  }

  _createClass(Calendar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          date = _props.date,
          dateFormat = _props.dateFormat;

      if (date.length > 0) {
        var parsedDate = (0, _moment2.default)(date, dateFormat);
        return this.setDate(parsedDate, dateFormat);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var date = nextProps.date,
          dateFormat = nextProps.dateFormat;

      if (date.length > 0) {
        var parsedDate = (0, _moment2.default)(date, dateFormat);
        return this.setDate(parsedDate, dateFormat);
      }
    }
  }, {
    key: 'setDate',
    value: function setDate(date, dateFormat) {
      this.setState({
        date: date,
        firstDayInMonth: (0, _moment2.default)(date, dateFormat).startOf('month').weekday(),
        daysInMonth: (0, _moment2.default)(date, dateFormat).daysInMonth()
      });
    }
  }, {
    key: 'changeMonth',
    value: function changeMonth(direction) {
      var dateFormat = this.props.dateFormat;
      var date = this.state.date;
      var newDate = (0, _moment2.default)(date, dateFormat).add(direction, 'M').date(1);
      this.setDate(newDate, dateFormat);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          cx = _props2.cx,
          newStyles = _props2.newStyles;
      return _react2.default.createElement('div', {
        className: cx('root', {
          kauflandRed: newStyles === 'kauflandRed'
        })
      }, this.renderHeader(), this.renderDays());
    }
  }, {
    key: 'renderHeader',
    value: function renderHeader() {
      var _this2 = this;

      var cx = this.props.cx;
      var date = this.state.date;
      return _react2.default.createElement('div', {
        className: cx('header')
      }, _react2.default.createElement(ArrowIcon, {
        className: cx('previousMonth'),
        onClick: function onClick() {
          return _this2.changeMonth(-1);
        }
      }), _react2.default.createElement('span', {
        className: cx('month')
      }, (0, _moment2.default)(date).format('MMMM YYYY')), _react2.default.createElement(ArrowIcon, {
        className: cx('nextMonth'),
        onClick: function onClick() {
          return _this2.changeMonth(1);
        }
      }), _react2.default.createElement('ul', {
        className: cx('weekDays')
      }, this.renderDayNames()));
    }
  }, {
    key: 'renderDays',
    value: function renderDays() {
      var _this3 = this;

      var _props3 = this.props,
          cx = _props3.cx,
          from = _props3.from,
          to = _props3.to,
          dateFormat = _props3.dateFormat;
      var _state = this.state,
          date = _state.date,
          daysInMonth = _state.daysInMonth,
          firstDayInMonth = _state.firstDayInMonth;
      var previousDaysInMonth = (0, _moment2.default)(date, dateFormat).add(-1, 'M').daysInMonth();
      var today = (0, _moment2.default)().startOf('day');
      return _react2.default.createElement('ul', {
        className: cx('body')
      }, [].concat(_toConsumableArray(Array(firstDayInMonth))).map(function (e, index) {
        return _react2.default.createElement('li', {
          key: index
        }, _react2.default.createElement('span', {
          className: cx('inactive')
        }, previousDaysInMonth - firstDayInMonth + index + 1));
      }), [].concat(_toConsumableArray(Array(daysInMonth))).map(function (e, index) {
        var currentDay = (0, _moment2.default)(date, dateFormat).date(index + 1);
        var selectedDate = (0, _moment2.default)(date, dateFormat).date() - 1;
        var isFromBanned = from && (0, _moment2.default)(from, dateFormat).isAfter(currentDay, 'days');
        var isToBanned = to && (0, _moment2.default)(to, dateFormat).isBefore(currentDay, 'days');
        return _react2.default.createElement('li', {
          key: index
        }, _react2.default.createElement('span', {
          className: cx({
            active: index === selectedDate
          }, {
            today: today.isSame(currentDay, 'days'),
            inactive: isFromBanned || isToBanned
          }),
          onClick: function onClick() {
            return _this3.setDay(index + 1);
          }
        }, index + 1));
      }));
    }
  }]);

  return Calendar;
}(_react.Component);

Calendar.defaultProps = {
  handleChange: function handleChange() {},
  getDateString: function getDateString() {},
  date: '',
  dateFormat: 'DD/MM/YYYY',
  language: 'pl-PL'
};
exports.default = (0, _reactHoc.withStyles)(_CalendarModule2.default)(Calendar);
module.exports = exports.default;